import * as _ from 'lodash';

import template from './armAway.html';

class ArmAwayController {
    /*@ngInject*/
    constructor(deviceActions, constants, $state, $interval) {
        this.deviceActions = deviceActions;
        this.constants = constants;
        this.$state = $state;
        this.$interval = $interval;
        this.isPanelArmedAway = false;
        this.canSkip = false;
    }

    $onInit() {
        this.pollPanelStatus();
    }

    pollPanelStatus() {
        // number of milliseconds between each interval
        const intervalDelay = this.constants.polling.training.pollingInterval;
        // indefinite interval to keep checking for the panel status
        this.$interval(() => {
            this.deviceActions.getPanelStatus().then((result) => {
                let panelStatus = result;
                this.isPanelArmedAway = panelStatus === this.constants.deviceStatus.armedAway.ID;
                this.canSkip = panelStatus === this.constants.deviceStatus.disarmed.ID;
            });
        }, intervalDelay);
    }

    skip() {
        this.$state.go('airfx.modswapSuccess');
    }
}

export default {
    template: template,
    bindings: {},
    controller: ArmAwayController
};